import { TenantLogoSection } from './../tenant-logo/tenant-logo.component';
import { selectCxbRootLevelRoles, selectCxbSelectedTenant, selectCxbTenantOptions } from './../../../../app.selectors';
import { filter, map } from 'rxjs/operators';
import { combineLatest, Subject } from 'rxjs';
import { AuthService } from './../../../../core/services/auth.service';
import { switchCxbTenant } from './../../../../app.actions';
import { RootAppState } from './../../../../app.reducer';
import { ChangeDetectionStrategy, Component, OnInit, ElementRef, HostListener, OnDestroy } from '@angular/core';
import { Store } from '@ngrx/store';
import { MenuBarService } from '../menu-bar.service';
import { RouterState } from '@ngrx/router-store';
import { Router } from '@angular/router';

@Component({
  selector: 'osn-cxb-profile-menu',
  templateUrl: './profile-menu.component.html',
  styleUrls: ['./profile-menu.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProfileMenuComponent implements OnInit, OnDestroy {
  public userName$ = this.authService.user$.pipe(
    filter((user) => !!user),
    map((user) => user?.name || user?.username)
  );

  public userEmail$ = this.authService.user$.pipe(
    filter((user) => !!user),
    map((user) => user?.username)
  );

  public userId$ = this.authService.user$.pipe(
    filter((user) => !!user),
    map((user) => user?.localAccountId)
  );

  public selectedTenant$ = this.store.select(selectCxbSelectedTenant).pipe(filter((tenant) => !!tenant));
  public selectedTenantOptional$ = this.store.select(selectCxbSelectedTenant);
  public isMultipleTenantOptionsAvailable$ = this.store.select(selectCxbTenantOptions).pipe(
    filter((tenantOptions) => !!tenantOptions),
    map((tenantOptions) => tenantOptions.length > 1)
  );

  public dataForTenantSwitch$ = combineLatest([this.userId$, this.selectedTenantOptional$, this.isMultipleTenantOptionsAvailable$]);

  public isGeneralSettingsAvailable$ = this.store.select(selectCxbRootLevelRoles).pipe(map((rootLevelRoles) => !!rootLevelRoles?.length));

  public isNavigateToOnDemandContentGroupLinkAvailable$ = this.store.select(selectCxbRootLevelRoles).pipe(
    map((rootLevelRoles) => {
      return (
        !!rootLevelRoles?.length &&
        (rootLevelRoles.includes('OndemandContentGroupEditor') ||
          rootLevelRoles.includes('OndemandContentGroupViewer') ||
          rootLevelRoles.includes('OsntvStoreContentGroupEditor') ||
          rootLevelRoles.includes('OsntvStoreContentGroupEditor'))
      );
    })
  );

  public TenantLogoSection = TenantLogoSection;
  public menuVisible = false;

  private readonly destroyed$ = new Subject<void>();

  constructor(
    private readonly store: Store<RootAppState & RouterState>,
    private readonly eRef: ElementRef,
    private readonly menuBarService: MenuBarService,
    private readonly authService: AuthService,
    public readonly router: Router
  ) {}

  @HostListener('document:mousedown', ['$event'])
  public outsideClick(event) {
    if (!this.eRef.nativeElement.contains(event.target)) {
      this.menuVisible = false;
    }
  }

  public ngOnInit(): void {}

  public ngOnDestroy(): void {
    this.destroyed$.next();
    this.destroyed$.complete();
  }

  public toggleMenu() {
    this.menuVisible = !this.menuVisible;
  }

  public onLogoutClicked() {
    this.menuBarService.logout();
  }

  public onSwitchTenantClicked([userId, selectedTenant]) {
    this.store.dispatch(switchCxbTenant({ userId }));
    this.router.navigate(['select-tenant'], { state: { previousTenant: selectedTenant?.id } });
  }

  public onGeneralSettingsClicked() {
    if (this.router.url.startsWith('/root')) {
      this.router.navigate(['/pages']);
    } else {
      this.router.navigate(['/root']);
    }
    this.toggleMenu();
  }

  public onClickOnDemandContentGroups() {
    this.router.navigate(['/root/content-groups']);
    this.toggleMenu();
  }
}
